import { type FactoryTypeText } from '@common/types/factory';
import { type GoodsType } from '@common/types/goods';
import { type PlantTypeText } from '@common/types/plant';
import { type ResourceTypeText } from '@common/types/resource';
import {
  currencyImages,
  factoryImages,
  type ImageFormats,
  plantImages,
  resourceImages,
} from '@components/helpers/imagesImports';

// check if name exist as object field and return images objects
const getImagesObjectByCategory = (
  name: string,
): Record<string, Record<string, string>> | undefined => {
  if (name in currencyImages) {
    return currencyImages[name as keyof typeof currencyImages];
  }

  if (name in resourceImages) {
    return resourceImages[name as keyof typeof resourceImages];
  }

  if (name in plantImages) {
    return plantImages[name as keyof typeof plantImages];
  }

  if (name in factoryImages) {
    return factoryImages[name as keyof typeof factoryImages];
  }
};

// get goods icon in factory images
const getGoodsIcon = (name: string): string | undefined => {
  for (const factory in factoryImages) {
    const goods = factoryImages[factory as keyof typeof factoryImages];

    if (name in goods.icons) {
      return goods.icons[name as keyof typeof goods.icons];
    }
  }
};

interface UseGetImagePropsType {
  name:
    | ResourceTypeText
    | FactoryTypeText
    | PlantTypeText
    | GoodsType
    | 'cash'
    | 'tgem'
    | string;
  field?: string;
}
// name - its game item like wood, books, furniture_factory etc.
// field - ist field name for game items image object (factoryImages.furniture_factory[field])
// for goods field not required
const getImage = ({
  name,
  field,
}: UseGetImagePropsType):
  | {
      img: string;
      webp?: string;
      pngRight?: string;
      webpRight?: string;
    }
  | undefined => {
  const imageObject = getImagesObjectByCategory(name);

  if (imageObject && field) {
    if (field in imageObject) {
      const images = imageObject[field as keyof typeof imageObject];
      const formatImages = images as ImageFormats;

      return {
        img:
          'png' in formatImages
            ? (formatImages.png as string)
            : (formatImages.jpg as string),
        webp: formatImages.webp,
        pngRight: formatImages?.pngRight,
        webpRight: formatImages?.webpRight,
      };
    }
  } else {
    const goodsIcon = getGoodsIcon(name);

    return goodsIcon ? { img: goodsIcon } : undefined;
  }
};

export { getGoodsIcon, getImage, getImagesObjectByCategory };
